const staff        = require ('./staff/staff')
const warehouseApp = require ('./warehouse/warehouse-app')

export function start(settingsData){ //console.log('applications>', settingsData)

	if(settingsData.device.deviceType === 'desktop'){
		settingsData.typeApp = 'staff';
		staff.start(settingsData);
	}
	
	if(settingsData.device.deviceType === 'tv'){
		settingsData.typeApp = 'staff';
		staff.start(settingsData)
	}
	
	if(settingsData.device.deviceType === "smartphone"){
		settingsData.typeApp = 'warehouse';
		warehouseApp.start(settingsData)
	}

}